import { requestApi } from "./axiosHelper";

const rootUrl = process.env.NODE_ENV
  ? process.env.REACT_APP_API_ROOT_URL
  : "http://localhost:8000/api/v1";

const preEnrolEP = rootUrl + "/eoi";

const preEnrolAPI = {
  createNewPreEnrol: async (obj) => {
    const axiosData = {
      url: preEnrolEP,
      method: "post",
      data: obj,
    };
    const data = await requestApi(axiosData, true);
    return data;
  },

  addInstallment: async (obj) => {
    try {
      const axiosData = {
        url: `${preEnrolEP}/installment`,
        method: "post",
        data: obj,
      };
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return (
        error.response?.data || { status: "error", message: error.message }
      );
    }
  },

  fetchPreEnrols: async (_id) => {
    try {
      const axiosData = {
        url: _id ? `${preEnrolEP}/${_id}` : preEnrolEP,
        method: "get",
      };
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return (
        error.response?.data || { status: "error", message: error.message }
      );
    }
  },

  fetchLocationPreEnrols: async (params) => {
    try {
      const axiosData = {
        url: `${preEnrolEP}/location/branch?${params}`,
        method: "get",
      };
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return (
        error.response?.data || { status: "error", message: error.message }
      );
    }
  },

  updatePreEnrol: async (_id, obj) => {
    try {
      const axiosData = {
        url: `${preEnrolEP}/${_id}`,
        method: "put",
        data: obj,
      };
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return (
        error.response?.data || { status: "error", message: error.message }
      );
    }
  },

  deleteAPreEnrol: async (_id) => {
    try {
      const axiosData = {
        url: `${preEnrolEP}/${_id}`,
        method: "delete",
      };
      const data = await requestApi(axiosData, true);

      return data;
    } catch (error) {
      return (
        error.response?.data || { status: "error", message: error.message }
      );
    }
  },
  addPreEnrolmentNote: async (obj) => {
    const axiosData = {
      url: preEnrolEP + "/note",
      method: "put",
      data: obj,
    };
    const data = await requestApi(axiosData, true);
    return data;
  },
};

export default preEnrolAPI;
